import React from 'react'
import { Tabs, Tab } from 'shared/ui/Tabs';
import ClientsList from 'features/parties/components/clients/ClientsList';

const ClientGroupItem = ({item}) => {
  return (
    <div>
      <Tabs initialTab='clients'>
        <Tab key='clients' label='Клиенты'>
          <ClientsList clientgroup={item} />
        </Tab>
        <Tab key='statistics' label='Статистика'>
          <h1 className='p-4'>Статистика в разработке</h1>
        </Tab>
      </Tabs>
    </div>
  )
}

export default ClientGroupItem